import React, { useEffect, useRef, useState } from 'react';
import './App.css';

const videos = [
  '/images/reel3.mp4',
  '/images/reel2.mp4'
];

const VideoGallery = () => {
  const [videoIndex, setVideoIndex] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.load();
      video.play().catch(e => {
        console.warn("Autoplay failed:", e);
      });

      const handleEnded = () => {
        setVideoIndex(prev => (prev + 1) % videos.length); // Loop to the first after last
      };

      video.addEventListener('ended', handleEnded);

      return () => {
        video.removeEventListener('ended', handleEnded);
      };
    }
  }, [videoIndex]);

  return (
    <div className="video-gallery">
      <header className="gallery-header">
        <h1>Cherished Moments with the Cocoloco Family</h1>
        <p>
          Celebrate the laughter, love, and unforgettable memories we've created together.
          These moments capture the true spirit of togetherness that defines the Cocoloco family —
          a bond built on joy, unity, and heartfelt connection.
        </p>
      </header>

      <div className="main-video-container">
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          controls
          className="main-video"
        >
          <source src={videos[videoIndex]} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default VideoGallery;

